import axios from 'axios';

const state = {
    folders: []
};

const getters = {
    getFoldersFileManager: (state) => {
        return state.folders
    }
};

const mutations = {
    async populateFolders (state) {
        axios.get(_ROOT_PATH + '/admin/file-manager-atlas/buscar-pastas-arquivos')
            .then((response) => {
                state.folders = response.data;
            }).catch((err) => console.log(err));
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations
}